import React from 'react';
import { Quote, Star, BadgeCheck } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  quote: string;
  imageInitials: string;
  verified?: boolean;
  rating?: number;
  highlight?: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote,
  imageInitials,
  verified = true,
  rating = 5,
  highlight
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex flex-col h-full transform transition-all duration-300 hover:-translate-y-1 hover:shadow-xl relative overflow-hidden group" data-id="element-24">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-24 h-24 bg-blue-50 rounded-bl-full -mr-4 -mt-4 opacity-50 group-hover:scale-110 transition-transform duration-500" data-id="element-25"></div>

      <div className="flex items-center mb-4 relative z-10" data-id="element-26">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 text-blue-700 flex items-center justify-center font-bold text-xl mr-4 shrink-0 border-2 border-white shadow-sm" data-id="element-27">
          {imageInitials}
        </div>
        <div data-id="element-28">
          <div className="flex items-center gap-1" data-id="element-29">
            <h3 className="font-bold text-gray-900" data-id="element-30">{name}</h3>
            {verified && <BadgeCheck className="w-4 h-4 text-blue-500 fill-blue-100" data-id="element-31" />}
          </div>
          <p className="text-sm text-gray-600 font-medium" data-id="element-32">{role}</p>
          <p className="text-xs text-gray-400" data-id="element-33">{location}</p>
        </div>
      </div>

      <div className="flex mb-4" data-id="element-34">
        {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-35" />)}
      </div>

      {highlight && <div className="mb-3 bg-green-50 text-green-700 text-xs font-bold px-3 py-1 rounded-full inline-block self-start border border-green-100" data-id="element-36">
          {highlight}
        </div>}

      <div className="relative flex-grow" data-id="element-37">
        <Quote className="absolute -top-2 -left-2 w-8 h-8 text-blue-100 transform -scale-x-100" data-id="element-38" />
        <p className="text-gray-700 italic relative z-10 pl-4 leading-relaxed" data-id="element-39">
          "{quote}"
        </p>
      </div>

      {verified && <div className="mt-4 pt-3 border-t border-gray-100 text-xs text-gray-400 flex items-center" data-id="element-40">
          <span className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse" data-id="element-41"></span>
          Compra verificada
        </div>}
    </div>;
}